
define('text!views/index.html',[],function () { return '<div></div>';});

